//import 'ol/ol.css';
import { FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { MapLayerGroupType, INewGeometryConfig } from '../Shared/Models/MapConfigModels';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import GeometryType from 'ol/geom/GeometryType';
import { TableInLineEdits } from '../Shared/Utility/TableInLineEdits';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    placeholder_for_legalmodals2 = '#placeholder-for-legalmodals2',

    legalEventsEditForm = '#legalEventsEditForm',
    legalEventsEditLocation = '#legalEventsEditLocation',
    legalEventsEditLocationAdminAreasTable = '#legalEventsEditLocationAdminAreasTable'
}

export class LegalAdminArea {
    legalGuid: string;
    adminArea: string;
    adminAreaDescr: string;
}

export class legalEvents_Location {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private adminAreas: Array<LegalAdminArea>;

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        const self = this;
    }

    public initEvents = (): void => {
        
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
   
    public initMainPanel = (data: ICAMSKey): void => {
        const self = this;

        $(jqc.legalEventsEditLocation + ' [name="locationSelect"]').on('change', function () {
            var val = $(this).find("option:selected").val() as any;
            var text = $(this).find("option:selected").text() as any;
            var legalGuid = Utilities.GetControl(jqc.legalEventsEditForm + ' [name="GUID"]').val() as any;
            var newAdminArea:LegalAdminArea = { legalGuid: legalGuid, adminArea: val, adminAreaDescr: text };

            self.UpdateAdminAreas(newAdminArea);
        });

        // Init table
        var tableLocation: any = Utilities.GetControl(jqc.legalEventsEditLocationAdminAreasTable);
        tableLocation.bootstrapTable();
        tableLocation.on('click-cell.bs.table', function (e, field, value, row, $element) {
            if (field == "Trash") {
                var legalGuid = Utilities.GetControl(jqc.legalEventsEditForm + ' [name="GUID"]').val() as any;
                self.DeleteAdminArea({ legalGuid: legalGuid, adminArea: row.adminArea, adminAreaDescr: row.adminAreaDescr });
            }
        });

        // Get data
        self.GetLegalAdminAreas();
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetLegalAdminAreas = (): void => {
        const self = this;
   
        var legalGuid = Utilities.GetControl(jqc.legalEventsEditForm + ' [name="GUID"]').val();
        let url = "/Legal/GetLegalAdminAreas";
        let query = { legalGuid: legalGuid };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.adminAreas = result.data;
                        var tableLocation: any = Utilities.GetControl(jqc.legalEventsEditLocationAdminAreasTable);
                        tableLocation.bootstrapTable('load', self.adminAreas);
                    }
                    else {
                        toastr.error('Failed to get location data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    public UpdateAdminAreas = (newAdminArea: LegalAdminArea) => {
        const self = this;

        self.adminAreas.push(newAdminArea);

        let url = "/Legal/UpdateAdminAreas";
        let query = { data: self.adminAreas };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success != true) {
                        toastr.error('Failed to update location data!')
                    }
                    else {
                        toastr.success('Added feature.');
                        ($(jqc.legalEventsEditLocation + ' [name="locationSelect"]') as any).prop('selectedIndex', 0);

                        self.GetLegalAdminAreas();
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE FROM SERVER
    private DeleteAdminArea = (newAdminArea: LegalAdminArea): void => {
        const self = this;

        let url = "/Legal/DeleteAdminAreas";
        let query = { data: [newAdminArea]};

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.success('Deleted feature.');
                        self.GetLegalAdminAreas();
                    }
                    else {
                        toastr.error("Failed to delete item.")
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }
}




